<template>
  <div class></div>
</template>

<script>
import wx from "weixin-jsapi";
export default {
  name: "",
  data() {
    return {};
  },
  components: {},
  created() {},
  mounted() {
    this.$store.commit("CShttp", this.$CShttp);
    this.$store.commit("ZChttp", this.$ZChttp);
    this.$store.commit("Loginhttp", this.$Loginhttp);

    var wxUserCode = this.getUrlKey("code", window.location.href);
    //店铺分享  有参数
    var type = this.getUrlKey("type", window.location.href);
    var id = this.getUrlKey("id", window.location.href);
    var shopid = this.getUrlKey("shopid", window.location.href);
    console.log("type", type);
    localStorage.setItem("shareShop", "");
    localStorage.setItem("shopIndex", "");
    localStorage.setItem("toUse", "");
    localStorage.setItem("ActiveCoupon", "");
    if (type == "shopIndex") {
      localStorage.setItem(
        "shareShop",
        JSON.stringify({ type: "shopIndex", id: id })
      );
    }
    if (type == "getCoupon") {
      localStorage.setItem(
        "getCoupon",
        JSON.stringify({ type: "getCoupon", id: id, shop_id: shopid })
      );
    }
    //转增优惠券
    if (type == "giveTo") {
      var pcodes = this.getUrlKey("pcodes", window.location.href);
      localStorage.setItem(
        "giveTo",
        JSON.stringify({ type: "giveTo", id: id, pcodes: pcodes })
      );
    }

        //活动优惠券
    if (type == "active") {
       var shop_id = this.getUrlKey("shopID", window.location.href);
       var activeID = this.getUrlKey("activeID", window.location.href);
       var activeMoney= this.getUrlKey("activeMoney", window.location.href);
      localStorage.setItem(
        "ActiveCoupon",
        JSON.stringify({ type: "ActiveCoupon", shop_id: shop_id, activeID: activeID ,activeMoney:activeMoney})
      );
    }

    this.wxUserCode = wxUserCode;
    //已经登陆过，有localstorage
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    localStorage.getItem("ZQUserSelf")
      ? this.$store.commit(
          "ZQUserSelf",
          JSON.parse(localStorage.getItem("ZQUserSelf"))
        )
      : "";
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo,
    });
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;



    // 测试  固定openid       uid  46  47    48   49 
    // openid = "oGgKWs0BMBZGAK2D_HrofAlfR6gA";
    // this.openid = "oGgKWs0BMBZGAK2D_HrofAlfR6gA";
    // var ZQUserSelf='{"id":47,"username":"oGgKWs0BMBZGAK2D_HrofAlfR6gA","nickname":"(ಥ_ಥ)","mobile":"15876815417","avatar":"http://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIp6hkjJREyMtQHIhLxNT6UzAS66G25FUZXJiahgTErmraOmXXzFlpD4cK4QyEzcVAsxygsssAW4Kw/132","score":0,"token":"6eb79deb-fbd7-42da-a08d-2fb6aff8ca26","user_id":"48","createtime":1587535726,"expiretime":1590127726,"expires_in":2592000}'
    // this.$store.commit(
    //       "UserSelf",
    //       JSON.parse(ZQUserSelf)
    //     )
    // localStorage.setItem("ZQlocation", '{"log":120.21848115098466,"lat":30.214433027298014}')
    // this.$store.commit("location",{"log":120.21848115098466,"lat":30.214433027298014});
    // localStorage.setItem("ZQUserSelf", ZQUserSelf);
    // this.$store.commit("UserInfo", {
    //   UserInfo: UserInfo
    // });
    // localStorage.setItem("ZQopenid", openid);
    // this.UserInfo = UserInfo;
    // this.openid = UserInfo.openid;
    // this.$router.push({ path: "/Home", query: {} }); //测试  跳转页面
    // return



    console.log("UserInfo", UserInfo);
    console.log("openid", openid);
    if (!wxUserCode && !openid) {
      //没有授权，第一次进入，跳转后台获取code
      window.location.href = this.$store.state.CShttp + "/api/shop/getcode";
    } else if (wxUserCode && !openid) {
      //获取code后请求openid等信息
      this.GetInfo();
    }else if(!openid||!UserInfo){
       this.GetInfo();
    } else if (openid && UserInfo) {
      //已经登陆过，有openid缓存
      this.GetWx();
    }
  },
  methods: {
    // 火星坐标转百度坐标
    change(lat, lng) {
      var x_PI = (3.14159265358979324 * 3000.0) / 180.0;
      var PI = 3.1415926535897932384626;
      var z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * x_PI);
      var theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * x_PI);
      var lng = z * Math.cos(theta) + 0.0065;
      var lat = z * Math.sin(theta) + 0.006;
      this.$store.commit("location", { log: lng, lat: lat });
      localStorage.setItem("ZQlocation", JSON.stringify({ log: lng, lat: lat }));
    },
    //获取openid
    GetInfo() {
      var that = this;
      console.log("code",this.wxUserCode)
      this.$http
        .get("/api/shop/get_userinfo", {
          params: {
            code: this.wxUserCode,
          },
        })
        .then((res) => {
          console.log("res", res);
          localStorage.setItem("ZQopenid", res.data.msg.openid);
          localStorage.setItem("ZQUserInfo", JSON.stringify(res.data.msg));
          that.$store.commit("UserInfo", {
            UserInfo: res.data.msg,
          });
          that.GetWx();
        });
    },
    //获取经纬度等微信信息，调用jsdk微信接口
    GetWx() {
      var that = this;
      if (!window.entryUrl) {
        window.entryUrl = window.location.href.split("#")[0];
      }
      var IsPhone = /iphone/.test(navigator.userAgent.toLowerCase()); //判断是不是苹果
      console.log(IsPhone, window.location.href.split("#")[0]);
      this.$http
        .get("/api/shop/get_SignPackage", {
          params: {
            url: IsPhone
              ? encodeURIComponent(window.entryUrl)
              : encodeURIComponent(location.href),
          },
        })
        .then((res) => {
          console.log(res.data.msg);
          that.$store.commit("wxJSSDK", res.data.msg);
          wx.config({
            debug: false, // true:调试时候弹窗
            appId: res.data.msg.appId, // 微信appid
            timestamp: res.data.msg.timestamp, // 时间戳
            nonceStr: res.data.msg.nonceStr, // 随机字符串
            signature: res.data.msg.signature, // 签名
            jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
              "getLocation", //获取地理位置
            ],
          });
          setInterval(() => {
            wx.config({
              debug: false, // true:调试时候弹窗
              appId: res.data.msg.appId, // 微信appid
              timestamp: res.data.msg.timestamp, // 时间戳
              nonceStr: res.data.msg.nonceStr, // 随机字符串
              signature: res.data.msg.signature, // 签名
              jsApiList: [
                // 所有要调用的 API 都要加到这个列表中
                "getLocation", //获取地理位置
              ],
            });
          }, 120000);
        });
      wx.ready(function () {
        wx.getLocation({
          type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            var speed = res.speed; // 速度，以米/每秒计
            var accuracy = res.accuracy; // 位置精度

            var location = that.change(latitude, longitude);
            that.getuseId();
          },
        });
      });
      wx.error(function () {
        // that.getuseId();
        console.log("失败??");
      });
    },
    //经纬度转换回调函数
    translateCallback(data) {
      console.log(data);
    },
    //获取用户id
    getuseId() {
      var that = this;
      console.log("UserInfo", that.$store.state.UserInfo);
      if (!that.$store.state.UserInfo || !that.$store.state.UserInfo.openid) {
        window.location.href = this.$store.state.CShttp + "/api/shop/getcode";
        return;
      }
      this.$http
        .get("/api/user/wxreglogin", {
          params: {
            openid: that.$store.state.UserInfo.openid,
            nickname: that.$store.state.UserInfo.nickname,
            avatar: that.$store.state.UserInfo.headimgurl,
          },
        })
        .then((res) => {
          console.log(res);
          localStorage.setItem(
            "ZQUserSelf",
            JSON.stringify(res.data.data.userinfo)
          );
          that.$store.commit("UserSelf", res.data.data.userinfo);
          that.$router.push({ path: "/Home", query: {} });
        });
    },
    //获取地址参数
    getUrlKey(name, url) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            url
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  },
};
</script>
<style lang='scss' scoped>
</style>
